import {
  Component,
  ViewChild,
  OnInit,
  EventEmitter,
  Output,
} from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { compare } from 'fast-json-patch';
import { BnNgIdleService } from 'bn-ng-idle'; // import it to your component

import {
  UntypedFormBuilder,
  FormArray,
  UntypedFormGroup,
  FormControl,
  Validators,
  Form,
} from '@angular/forms';

import { PagesService } from '../../services/pages.service';
import { AuthenticationService } from '../../services/authentication.service';
import { GeneralForm } from '../../models/GeneralForm';
import { EducationForm } from '../../models/EducationForm';
// import { EducationModel } from '../../models/EducationModel';
import { Consumer } from '../../models/Consumer';

import { DatePipe, formatDate } from '@angular/common';
import { WizardpageStep1GeneralComponent } from '../wizardpages/wizardpage-step1-General/wizardpage-step1.component';
import { WizardpageStep2WelcomeComponent } from '../wizardpages/wizardpage-step2-Welcome/wizardpage-step2.component';
import { WizardpageStep3ContactComponent } from '../wizardpages/wizardpage-step3-Contact/wizardpage-step3.component';
import { WizardpageStep4EducationComponent } from '../wizardpages/wizardpage-step4-Education/wizardpage-step4.component';
import { WizardpageStep5CredentialsComponent } from '../wizardpages/wizardpage-step5-Credentials/wizardpage-step5.component';
import { WizardpageStep6EligibilityComponent } from '../wizardpages/wizardpage-step6-Eligibility/wizardpage-step6.component';
import { WizardpageStep7AvailabilityComponent } from '../wizardpages/wizardpage-step7-Availability/wizardpage-step7.component';
import { WizardpageStep8SpecialtyComponent } from '../wizardpages/wizardpage-step8-Specialty/wizardpage-step8.component';
import { WizardpageStep11AdditonalQuestComponent } from '../wizardpages/wizardpage-step11-AdditionalQuests/wizardpage-step11.component';
import { WizardpageStep18ReviewComponent } from '../wizardpages/wizardpage-step18-Review/wizardpage-step18.component';
import { WizardpageStep9WorkHistoryComponent } from '../wizardpages/wizardpage-step9-WorkHistory/wizardpage-step9.component';
//changes Md
//import { WizardpageStep10ReferencesComponent } from '../wizardpages/wizardpage-step10-References/wizardpage-step10.component';
import { WizardpageStep17TermsComponent } from '../wizardpages/wizardpage-step17-Terms/wizardpage-step17.component';



import { WizardpageStep12BasicExamComponent } from '../wizardpages/wizardpage-step12-BasicExam/wizardpage-step12.component';
import { WizardpageStep13PCAExamComponent } from '../wizardpages/wizardpage-step13-PCAExam/wizardpage-step13.component';
import { WizardpageStep14CertifiedExamComponent } from '../wizardpages/wizardpage-step14-CertifiedExam/wizardpage-step14.component';
import { WizardpageStep15HCAExamComponent } from '../wizardpages/wizardpage-step15-HomeCareAideExam/wizardpage-step15.component';
import { WizardpageStep16PharmExamComponent } from '../wizardpages/wizardpage-step16-PharmacologyExam/wizardpage-step16.component';





import { forkJoin, from, Subscription } from 'rxjs';
import { concatMap, mergeMap } from 'rxjs/operators';
import { EducationModel } from 'src/app/models/EducationModel';
import { WorkHistoryModel } from 'src/app/models/WorkHistoryModel';
import { ReferenceModel } from 'src/app/models/ReferenceModel';
import { ExamModel } from 'src/app/models/ExamModel';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';


@Component({
  selector: 'app-applicationwizard',
  templateUrl: './applicationwizard.component.html',
  providers: [PagesService, DatePipe],
  styleUrls: ['./applicationwizard.component.scss'],
})
export class ApplicationwizardComponent implements OnInit {
  // allows parent to comunicate with Dom objects in child. Use this of the @Input decortor in child so parent can bind to decorator
  @ViewChild(WizardpageStep1GeneralComponent, { static: false })
  private step1GeneralComponent: WizardpageStep1GeneralComponent;

  @ViewChild(WizardpageStep2WelcomeComponent, { static: false })
  private step2WelcomeComponent: WizardpageStep2WelcomeComponent;

  @ViewChild(WizardpageStep3ContactComponent, { static: false })
  private step3ContactComponent: WizardpageStep3ContactComponent;

  @ViewChild(WizardpageStep4EducationComponent, { static: false })
  private step4EducationComponent: WizardpageStep4EducationComponent;

  @ViewChild(WizardpageStep5CredentialsComponent, { static: false })
  private step5CredentialsComponent: WizardpageStep5CredentialsComponent;

  @ViewChild(WizardpageStep6EligibilityComponent, { static: false })
  private step6EligibilityComponent: WizardpageStep6EligibilityComponent;

  @ViewChild(WizardpageStep7AvailabilityComponent, { static: false })
  private step7AvailabilityComponent: WizardpageStep7AvailabilityComponent;

  @ViewChild(WizardpageStep8SpecialtyComponent, { static: false })
  private step8SpecialtyComponent: WizardpageStep8SpecialtyComponent;

  @ViewChild(WizardpageStep11AdditonalQuestComponent, { static: false })
  private step11AddQuestionsComponent: WizardpageStep11AdditonalQuestComponent;

  @ViewChild(WizardpageStep18ReviewComponent, { static: false })
  private step18ReviewComponent: WizardpageStep18ReviewComponent;

  @ViewChild(WizardpageStep9WorkHistoryComponent, { static: false })
  private step9WorkHistoryComponent: WizardpageStep9WorkHistoryComponent;
  //changes Md
  //@ViewChild(WizardpageStep10ReferencesComponent, { static: false })
  //private step10ReferencesComponent: WizardpageStep10ReferencesComponent;

  @ViewChild(WizardpageStep17TermsComponent, { static: false })
  private step17TermsComponent: WizardpageStep17TermsComponent;


  @ViewChild(WizardpageStep12BasicExamComponent , { static: false })
  private stepBasicComponent: WizardpageStep12BasicExamComponent ;

  @ViewChild(WizardpageStep13PCAExamComponent , { static: false })
  private stepPCAComponent: WizardpageStep13PCAExamComponent ;

  @ViewChild(WizardpageStep14CertifiedExamComponent , { static: false })
  private stepCertifiedComponent: WizardpageStep14CertifiedExamComponent ;

  @ViewChild(WizardpageStep15HCAExamComponent , { static: false })
  private stepHCAComponent: WizardpageStep15HCAExamComponent ;

  @ViewChild(WizardpageStep16PharmExamComponent , { static: false })
  private stepPharmComponent: WizardpageStep16PharmExamComponent ;


  @ViewChild('stepper') stepper: MatStepper;


  returnUrl: string;
  isDesktop: boolean;
  isCompleted = [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false];
  pagenumber = 1;
  totalpage = 0;
  public User: string;

 // edmodel: EducationModel;

  // tslint:disable-next-line:max-line-length
  constructor(
    private fb: UntypedFormBuilder,
    private pagesService: PagesService,
    private deviceService: DeviceDetectorService,
    private authenticationService: AuthenticationService,
    private bnIdle: BnNgIdleService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
  ) {


    this.isDesktop = this.deviceService.isDesktop();
    const applicantName = localStorage.getItem('employee_name');
    this.User = applicantName; // needs to be put back when live
   // console.log('currentUser', localStorage.getItem('currentUser'));
  }




  title =
    'Angular Material Stepper Example with single ' +
    'Reactive form across mulitple child components';

  // paregistrationForm: FormGroup;
  appgeneralForm: UntypedFormGroup;
  appeducationForm: UntypedFormGroup;
  appworkhistoryForm: UntypedFormGroup;
  appreferencesForm: UntypedFormGroup;
  appexamForm: UntypedFormGroup;

  appbasicexamForm: UntypedFormGroup;
  apppcaexamForm: UntypedFormGroup;
  appcertexamForm: UntypedFormGroup;
  apppharmexamForm: UntypedFormGroup;
  apphomecareexamForm: UntypedFormGroup;


  testname: string;


  public generalForm: GeneralForm;
  educationModel: EducationModel[] = [];
  workhistoryModel: WorkHistoryModel[] = [];
  referenceModel: ReferenceModel[] = [];
  examModel: ExamModel;
   // public educationForm: EducationForm;
   // educationForm: EducationForm;





 // public consumer: Consumer;
 // private enrollId: string;
  private appId: string;
  public selectedIndex: number;
  public headerclicked: boolean;
  public bpSub: Subscription;

  genForm: any;
  conForm: any;
  credForm: any;
  eligForm: any;
  availForm: any;
  specialForm: any;
  additionalForm: any;
  wizsteps: any;



  ngOnInit(): void {
    this.appId = localStorage.getItem('id');
   // this.enrollType = localStorage.getItem('enroll_type');

    this.bnIdle.startWatching(3600).subscribe((isTimedOut: boolean) => { // 30 min timeout
    if (isTimedOut) {

      const currentuser = localStorage.getItem('currentUser');


      if (currentuser !== null) {
        this.authenticationService.logout();
      }
      this.bnIdle.stopTimer();

      this.router.navigateByUrl('/login');

      // add close Signal R connection and all subscriptions here

    }
  });
    this.getGeneralApplication(this.appId);

  }



  getWizardSteps(event: any) {

    this.pagesService.getWizardStepDetails(event).subscribe((retsteps) => {

      this.wizsteps = retsteps;

      const shownsteps = this.wizsteps.filter(d =>  d.IncludePage === true);

      this.totalpage = shownsteps.length;


    });
  }




  getGeneralApplication(appID: string) {


      this.pagesService.getGeneralFormDetails(appID).pipe(concatMap(genVal => {
// returns genVal
// this is the model we get back from webAPI
        this.generalForm = genVal; // [0].AdminPersonalAssistant
        this.initGenForm();

// this is the data inside the initial generalPage
        this.genForm = this.appgeneralForm.controls.generalPage.value;
        this.conForm = this.appgeneralForm.controls.contactPage.value;
        this.credForm = this.appgeneralForm.controls.credentialsPage.value;
        this.eligForm = this.appgeneralForm.controls.eligibilityPage.value;
        this.availForm = this.appgeneralForm.controls.availabilityPage.value;
        //changes Md (Remove SpecialyPage) 08/02/2022
        //this.specialForm = this.appgeneralForm.controls.specialtyPage.value;
        this.additionalForm = this.appgeneralForm.controls.additionalQuestPage.value;





         const branchID = genVal.branchId;
         const Position = genVal.position;
         const rechangedata = {
          position : Position === null ? 0 : Position,
          branchId: branchID === null ? 0  : branchID,
          appId: appID
         };



        return  this.pagesService.getWizardStepDetails(rechangedata);
        })

        ).subscribe((retsteps) => {
            // holds step name, include page and ordinal for all the steps
          this.wizsteps = retsteps;



          const examsteps = this.wizsteps.filter(d =>  d.Ordinal > 11);
          const shownsteps = this.wizsteps.filter(d =>  d.IncludePage === true);

          this.totalpage = shownsteps.length;

          console.log('Test12', this.totalpage);

          // Changes Md
          /*
          examsteps.forEach ((item, index) => {

          //  console.log('Loops', item);
            switch (item.StepName) {

              case 'Basic Exam':
                this.pagesService.getExamDetails(appID, '1').subscribe((examresult) => {
                 this.examModel = examresult;
                 this.initExamForm(); // populates appexamForm
                 // this.examModel = null;
                 this.appbasicexamForm = this.appexamForm;
                 this.appexamForm = null;
               }
               );
                break;
              case 'PCA Exam':
                this.pagesService.getExamDetails(appID, '3').subscribe((examresult) => {
                  this.examModel = examresult;
                  this.initExamForm(); // populates appexamForm
                  // this.examModel = null;
                  this.apppcaexamForm = this.appexamForm;
                  this.appexamForm = null;
                }
                );
                break;
              case 'Certified Exam':
                  this.pagesService.getExamDetails(appID, '2').subscribe((examresult) => {
                    this.examModel = examresult;
                    this.initExamForm(); // populates appexamForm
                    // this.examModel = null;
                    this.appcertexamForm = this.appexamForm;
                    this.appexamForm = null;
                  }
                  );
                  break;
              case 'Pharmacology Exam':
                    this.pagesService.getExamDetails(appID, '11').subscribe((examresult) => {
                      this.examModel = examresult;
                      this.initExamForm(); // populates appexamForm
                      // this.examModel = null;
                      this.apppharmexamForm = this.appexamForm;
                      this.appexamForm = null;
                    }
                    );
                    break;

               case 'Home Care Aide Exam':
                      this.pagesService.getExamDetails(appID, '10').subscribe((examresult) => {
                        this.examModel = examresult;
                        this.initExamForm(); // populates appexamForm
                        // this.examModel = null;
                        this.apphomecareexamForm = this.appexamForm;
                        this.appexamForm = null;
                      }
                      );
                      break;
              default:
                break;
            }
        });
        */

        });





      const education = this.pagesService.getEducationFormDetails(appID);
      const workhistory = this.pagesService.getWorkHistoryFormDetails(appID);
      const reference = this.pagesService.getWorkReferenceDetails(appID);

      // take action on the observable when data results are recieved for all. The observale version of Promise.all
      forkJoin([education, workhistory, reference]).subscribe(results => {


      setTimeout(() => {}, 700); // wait 7 milliseconds to load data

      this.educationModel = results[0];
      this.workhistoryModel = results[1];
      this.referenceModel = results[2];


      this.initEdForm();
      this.initWorkHistoryForm();
      this.initRefForm();

    });


  }



  submitGeneralPage(applicationData: any) {

    this.pagesService
      .updateGeneral(applicationData)
      .subscribe((retval) => {
      this.step1GeneralComponent.isFetching(false);

      this.isCompleted[0] = true;

      setTimeout(() => { this.stepper.next(); }, 200);


      });

  }




  submitWelcome(applicationData: any, buttonclicked: any) {

    this.step2WelcomeComponent.isFetching(true);


    this.step2WelcomeComponent.isFetching(false);

    this.isCompleted[1] = true;
    setTimeout(() => { this.stepper.next(); }, 200);

  }



  submitContact(applicationData: any, buttonclicked: any) {

    this.pagesService
          .updateGeneral(applicationData)
          .subscribe((retval) => {

            this.step3ContactComponent.isFetching(false);
            this.isCompleted[2] = true;
            setTimeout(() => { this.stepper.next(); }, 200);
          });
  }


  //Changes Md Remove Exams 08/03/2022

  submitExams(applicationData: any, buttonclicked: any) {

    this.pagesService
          .updateExams(applicationData)
          .subscribe((retval) => {

            if (this.stepBasicComponent !== undefined) {
            this.stepBasicComponent.isFetching(true); }

            if (this.stepPCAComponent !== undefined) {
              this.stepPCAComponent.isFetching(true); }

            if (this.stepCertifiedComponent !== undefined) {
              this.stepCertifiedComponent.isFetching(true); }

            if (this.stepHCAComponent !== undefined) {
              this.stepHCAComponent.isFetching(true); }

            if (this.stepPharmComponent !== undefined) {
              this.stepPharmComponent.isFetching(true); }

            this.isCompleted[11] = true;
            this.isCompleted[12] = true;
            this.isCompleted[13] = true;
            this.isCompleted[14] = true;
            this.isCompleted[15] = true;
            setTimeout(() => { this.stepper.next(); }, 200);
          });
  }

  submitEducation(applicationData: any, buttonclicked: any) {

  const post =
    [
       // HIGHSCHOOL
       {
         Id : applicationData.value.Id,
         Type : 'hs',
         Name : applicationData.value.HSName,
         Location : applicationData.value.HSLocation,
         Last_Year_Completed : applicationData.value.HSLast_Year_Completed,
         Graduate : applicationData.value.HSGraduate,
         GED : applicationData.value.GED,
         ApplicantFormId : applicationData.value.ApplicantFormId
     },
      // COLLEGE
     {

       Id : applicationData.value.Id1,
       Type : 'co',
       Name : applicationData.value.ColName,
       Location : applicationData.value.ColLocation,
       Last_Year_Completed : applicationData.value.ColLast_Year_Completed,
       Graduate : applicationData.value.ColGraduate,
       Major_Course : applicationData.value.ColMajor_Course,
       Diploma_Degree : applicationData.value.ColDiploma_Degree,
       ApplicantFormId : applicationData.value.ApplicantFormId

     },

     // OTHER
     {

       Id : applicationData.value.Id2,
       Type : 'ce',
       Name : applicationData.value.OTHName,
       Location : applicationData.value.OTHLocation,
       Last_Year_Completed : applicationData.value.OTHLast_Year_Completed,
       Graduate : applicationData.value.OTHGraduate,
       Major_Course : applicationData.value.OTHMajor_Course,
       Diploma_Degree : applicationData.value.OTHDiploma_Degree,
       ApplicantFormId : applicationData.value.ApplicantFormId

     }
   ];

 this.pagesService
          .updateEducation(post)
          .subscribe((retval) => {


            this.educationModel = retval;
            this.step4EducationComponent.isFetching(false);
            this.isCompleted[3] = true;
            setTimeout(() => {  this.stepper.next(); }, 200);
          });
  }



  submitWorkHistory(applicationData: any, buttonclicked: any) {


// First Job
 const post =
    [
       {
        Id:   applicationData.value.Id1,
        COAUTH: applicationData.value.CO1AUTH === true ? 'Yes' : 'No',
        CONAME: applicationData.value.CO1NAME,
        COFROMMTH1: applicationData.value.CO1FROMMTH1,
        COFROMYR: applicationData.value.CO1FROMYR === undefined ? applicationData.value.CO1FROMYR :  applicationData.value.CO1FROMYR.trim(),
        COTOMTH1: applicationData.value.CO1TOMTH1,
        COTOYR: applicationData.value.CO1TOYR === undefined ? applicationData.value.CO1TOYR :  applicationData.value.CO1TOYR.trim(),
        COADD: applicationData.value.CO1ADD,
        COADD2: applicationData.value.CO1ADD2,
        COPOS: applicationData.value.CO1POS,
        SUPER: applicationData.value.SUPER,
        COPHONE: applicationData.value.CO1PHONE,
        COEMAIL: applicationData.value.CO1EMAIL,
        COREASON: applicationData.value.CO1REASON,
        ApplicantFormId: applicationData.value.ApplicantFormId,
        Whar: applicationData.value.WHAR === true ? 'Yes' : 'No',
        noemploy: applicationData.value.noemploy === true ? 'Yes' : 'No',
        noemployexp: applicationData.value.noemployexp

     },
// Second Job
     {

      Id : applicationData.value.Id2,
      COAUTH:  applicationData.value.CO2AUTH === true ? 'Yes' : 'No',
      CONAME:  applicationData.value.CO2NAME,
      COFROMMTH1:  applicationData.value.CO2FROMMTH2,
      COFROMYR:  applicationData.value.CO2FROMYR === undefined ? applicationData.value.CO2FROMYR :  applicationData.value.CO2FROMYR.trim(),
      COTOMTH1:  applicationData.value.CO2TOMTH2,
      COTOYR:  applicationData.value.CO2TOYR === undefined ? applicationData.value.CO2TOYR :  applicationData.value.CO2TOYR.trim(),
      COADD:  applicationData.value.CO2ADD,
      COADD2:  applicationData.value.CO2ADD2,
      COPOS:  applicationData.value.CO2POS,
      SUPER:  applicationData.value.SUPER2,
      COPHONE:  applicationData.value.CO2PHONE,
      COEMAIL:  applicationData.value.CO2EMAIL,
      COREASON:  applicationData.value.CO2REASON,
      ApplicantFormId: applicationData.value.ApplicantFormId,
      Whar: applicationData.value.WHAR === true ? 'Yes' : 'No',
      noemploy: applicationData.value.noemploy === true ? 'Yes' : 'No',
      noemployexp: applicationData.value.noemployexp

     },

// Third Job
     {

      Id:    applicationData.value.Id3,
      COAUTH:  applicationData.value.CO3AUTH === true ? 'Yes' : 'No',
      CONAME:  applicationData.value.CO3NAME,
      COFROMMTH1:  applicationData.value.CO3FROMMTH3,
      COFROMYR:  applicationData.value.CO3FROMYR === undefined ? applicationData.value.CO3FROMYR :  applicationData.value.CO3FROMYR.trim(),
      COTOMTH1:  applicationData.value.CO3TOMTH3,
      COTOYR:  applicationData.value.CO3TOYR === undefined ? applicationData.value.CO3TOYR :  applicationData.value.CO3TOYR.trim(),
      COADD:  applicationData.value.CO3ADD,
      COADD2:  applicationData.value.CO3ADD2,
      COPOS:  applicationData.value.CO3POS,
      SUPER:  applicationData.value.SUPER3,
      COPHONE:  applicationData.value.CO3PHONE,
      COEMAIL:  applicationData.value.CO3EMAIL,
      COREASON:  applicationData.value.CO3REASON,
      ApplicantFormId: applicationData.value.ApplicantFormId,
      Whar: applicationData.value.WHAR === true ? 'Yes' : 'No',
      noemploy: applicationData.value.noemploy === true ? 'Yes' : 'No',
      noemployexp: applicationData.value.noemployexp

     }
   ];





 this.pagesService
          .updateWorkHistory(post)
          .subscribe((retval) => {


            this.workhistoryModel = retval;


            this.step9WorkHistoryComponent.isFetching(false);
            this.isCompleted[8] = true;
            setTimeout(() => {  this.stepper.next(); }, 200);
          });
  }





submitReferences(applicationData: any, buttonclicked: any) {


 const post =
 [
    // HIGHSCHOOL
    {

      Id : applicationData.value.Id,
      ReferenceName : applicationData.value.ReferenceName,
      ReferenceSupervisor : applicationData.value.ReferenceSupervisor,
      ReferenceAddress : applicationData.value.ReferenceAddress,
      ReferenceTelephone :  applicationData.value.ReferenceTelephone,
      ReferenceEmail :  applicationData.value.ReferenceEmail,
      ReferenceFax :  applicationData.value.ReferenceFax,
      ApplicantFormId : applicationData.value.ApplicantFormId
  },
   // COLLEGE
  {

    Id : applicationData.value.Id1,
    ReferenceName : applicationData.value.ReferenceName1,
    ReferenceSupervisor : applicationData.value.ReferenceSupervisor1,
    ReferenceAddress : applicationData.value.ReferenceAddress1,
    ReferenceTelephone :  applicationData.value.ReferenceTelephone1,
    ReferenceEmail :  applicationData.value.ReferenceEmail1,
    ReferenceFax :  applicationData.value.ReferenceFax1,
    ApplicantFormId : applicationData.value.ApplicantFormId


  },

  // OTHER
  {

    Id : applicationData.value.Id2,
    ReferenceName : applicationData.value.ReferenceName2,
    ReferenceSupervisor : applicationData.value.ReferenceSupervisor2,
    ReferenceAddress : applicationData.value.ReferenceAddress2,
    ReferenceTelephone :  applicationData.value.ReferenceTelephone2,
    ReferenceEmail :  applicationData.value.ReferenceEmail2,
    ReferenceFax :  applicationData.value.ReferenceFax2,
    ApplicantFormId : applicationData.value.ApplicantFormId

  }

];






 this.pagesService
          .updateReferences(post)
          .subscribe((retval) => {

            this.referenceModel = retval;
            //Changes Md 08/02/2022
            //this.step10ReferencesComponent.isFetching(false);
            this.isCompleted[9] = true;
            setTimeout(() => { this.stepper.next(); }, 200);
          });
  }




  submitCredentials(applicationData: any, buttonclicked: any) {

    this.pagesService
          .updateGeneral(applicationData)
          .subscribe((retval) => {

            this.step5CredentialsComponent.isFetching(false);

            this.isCompleted[4] = true;
            setTimeout(() => { this.stepper.next(); }, 200);
          });
  }




  submitEligibility(applicationData: any, buttonclicked: any) {

    this.pagesService
          .updateGeneral(applicationData)
          .subscribe((retval) => {

            this.step6EligibilityComponent.isFetching(false);
            this.isCompleted[5] = true;
            setTimeout(() => { this.stepper.next(); }, 500);
          });
  }


  submitAvailability(applicationData: any, buttonclicked: any) {

    this.pagesService
          .updateGeneral(applicationData)
          .subscribe((retval) => {

            this.step7AvailabilityComponent.isFetching(false);
            this.isCompleted[6] = true;
            setTimeout(() => { this.stepper.next(); }, 200);
          });
  }


//changes Md (specialtyPage) 08/02/2022
/*
  submitSpecialty(applicationData: any, buttonclicked: any) {

    this.pagesService
          .updateGeneral(applicationData)
          .subscribe((retval) => {

            this.step8SpecialtyComponent.isFetching(false);
            this.isCompleted[7] = true;
            setTimeout(() => { this.stepper.next(); }, 200);
          });
  }
*/


  submitAddQuestions(applicationData: any, buttonclicked: any) {

    this.pagesService
          .updateGeneral(applicationData)
          .subscribe((retval) => {

           this.step11AddQuestionsComponent.isFetching(false);
           this.isCompleted[10] = true;
           setTimeout(() => { this.stepper.next(); }, 200);
          });
  }




  submitTerms(applicationData: any, buttonclicked: any) {

    this.pagesService
          .updateGeneral(applicationData)
          .subscribe((retval) => {

           this.step17TermsComponent.isFetching(false);
           this.isCompleted[16] = true;
           setTimeout(() => { this.stepper.next(); }, 200);
          });

  // this.stepper.next();
  }



  submitApplication(applicationData: any, buttonclicked: any) {


   // console.log('GeneralData', applicationData);

    this.pagesService
    .updateAutoStatus(applicationData).subscribe((retval) => {

      this.authenticationService.logout();

      this.isCompleted[17] = true;
      setTimeout(() => { this.router.navigate(['/thankyou']); }, 200);


    });

  }




  pageCountNavigation(event: any): void {

    if (event === 1) {
    this.pagenumber = this.pagenumber + 1;
     } else { this.pagenumber = this.pagenumber - 1; }

  }




  logout() {

    localStorage.setItem('refreshClicked', 'true');
    this.authenticationService.logout();
  }

   initGenForm() {
    const patientFirstName = '';
    this.appgeneralForm = this.fb.group({
      // take these out and put
      generalPage: this.fb.group({
        Id: [this.appId],
        statusId: [3], // status for completing the employee application
        firstName: [this.generalForm.firstName, [Validators.required]],
        lastName: [this.generalForm.lastName, [Validators.required]],
        last4Ss: [this.generalForm.last4Ss, [Validators.required]],
        primaryPhone: [this.generalForm.primaryPhone, [Validators.required]],
        secondaryPhone: [this.generalForm.secondaryPhone],
        howDidYouHearId: [this.generalForm.howDidYouHearId, [Validators.required]],
        branchId: [this.generalForm.branchId, [Validators.required]],
        position: [this.generalForm.position, [Validators.required]],
        eMail: [this.generalForm.eMail, [Validators.required]],
        
        referredBy: [this.generalForm.referredBy],
        priLanguage: [this.generalForm.priLanguage, [Validators.required]], 
        
      }),
      contactPage: this.fb.group({
        firstName: [this.generalForm.firstName, [Validators.required]], // readonly
        lastName: [this.generalForm.lastName, [Validators.required]], // readonly
        email: [
          this.generalForm.eMail,
          [Validators.required, Validators.email],
        ], // readonly
        address: [this.generalForm.address, [Validators.required]],
        city: [this.generalForm.city, [Validators.required]],
        state: [this.generalForm.state, [Validators.required]],
        zip: [this.generalForm.zip, [Validators.required]],
        pstname: [this.generalForm.pstname, [Validators.required]],
        pastname1: [this.generalForm.pastname1, [Validators.required]],
        txtpastname1: [
          this.generalForm.txtpastname1,
          [Validators.required],
        ],
        pastname2: [this.generalForm.pastname2],
        txtpastname2: [
          this.generalForm.txtpastname2],
        pastname3: [this.generalForm.pastname3],
        txtpastname3: [
          this.generalForm.txtpastname3],
        pstaddress: [this.generalForm.pstaddress, [Validators.required]],
        txtpastaddress1: [
          this.generalForm.txtpastaddress1,
          [Validators.required],
        ],
        txtpastaddressdate1: [
          this.generalForm.txtpastaddressdate1,
          [Validators.required],
        ],
        txtpastaddress2: [
          this.generalForm.txtpastaddress2
        ],
        txtpastaddressdate2: [
          this.generalForm.txtpastaddressdate2
        ],
        txtpastaddress3: [
          this.generalForm.txtpastaddress3
        ],
        txtpastaddressdate3: [
          this.generalForm.txtpastaddressdate3
        ],
      }),
      credentialsPage: this.fb.group({
        // tslint:disable-next-line:max-line-length
        Credentials: [this.generalForm.credentials == null ? this.generalForm.credentials : this.generalForm.credentials.trim(), [Validators.required]],
        // tslint:disable-next-line:max-line-length
        Hhlicstate: [this.generalForm.hhlicstate == null ? this.generalForm.hhlicstate : this.generalForm.hhlicstate.trim(), [Validators.required]],
        Hhlicno: [this.generalForm.hhlicno == null ? this.generalForm.hhlicno : this.generalForm.hhlicno.trim(), [Validators.required]],
        Hhlicexp: [formatDate(this.generalForm.hhlicexp, 'yyyy-MM-dd', 'en'), [Validators.required]],
        Proins: [this.generalForm.proins, [Validators.required]]
      }),
      eligibilityPage: this.fb.group({
        Legal: [this.generalForm.legal == null ? this.generalForm.legal : this.generalForm.legal.trim(), [Validators.required]],
        // changes Md
        // Crime: [this.generalForm.crime == null ? this.generalForm.crime : this.generalForm.crime.trim(), [Validators.required]],
        // Explain: [this.generalForm.explain == null ? this.generalForm.explain : this.generalForm.explain.trim(), [Validators.required]],
        // Adverse: [this.generalForm.adverse == null ? this.generalForm.adverse : this.generalForm.adverse.trim(), [Validators.required]],
        // ExplainAdverse: [this.generalForm.explainAdverse, [Validators.required]]
      }),
      availabilityPage: this.fb.group({
        Availfull: [this.generalForm.availfull == null ? this.generalForm.availfull : this.generalForm.availfull.trim()],
        Availpart: [this.generalForm.availpart == null ? this.generalForm.availpart : this.generalForm.availpart.trim()],
        Availwkend: [this.generalForm.availwkend == null ? this.generalForm.availwkend : this.generalForm.availwkend.trim()],
        Availdays: [this.generalForm.availdays == null ? this.generalForm.availdays : this.generalForm.availdays.trim()],
        Availeve: [this.generalForm.availeve == null ? this.generalForm.availeve : this.generalForm.availeve.trim()],
        Availvisits: [this.generalForm.availvisits == null ? this.generalForm.availvisits : this.generalForm.availvisits.trim()],
        Availdiem: [this.generalForm.availdiem == null ? this.generalForm.availdiem : this.generalForm.availdiem.trim()],
        Availother: [this.generalForm.availother == null ? this.generalForm.availother : this.generalForm.availother.trim()],
        Avail: [this.generalForm.avail == null ? this.generalForm.avail : this.generalForm.avail.trim(), [Validators.required]],
        Language: [this.generalForm.language == null ? this.generalForm.language : this.generalForm.language.trim(), [Validators.required]],
        //changes md 08/02/2022
        //Memberships: [this.generalForm.memberships == null ? this.generalForm.memberships : this.generalForm.memberships.trim()],
        Driver: [this.generalForm.driver == null ? this.generalForm.driver : this.generalForm.driver.trim(), [Validators.required]],
        Driver2: [this.generalForm.driver2 == null ? this.generalForm.driver2 : this.generalForm.driver2.trim(), [Validators.required]],
        Driver3: [this.generalForm.driver3 == null ? this.generalForm.driver3 : this.generalForm.driver3.trim(), [Validators.required]],
      }),
      /* changes md 08/02/2022
      specialtyPage: this.fb.group({
        HC: [this.generalForm.hc == null ? this.generalForm.hc : this.generalForm.hc.trim()],
        EXTCARE: [this.generalForm.extcare == null ? this.generalForm.extcare : this.generalForm.extcare.trim()],
        SURG: [this.generalForm.surg == null ? this.generalForm.surg : this.generalForm.surg.trim()],
        HOSPICE: [this.generalForm.hospice == null ? this.generalForm.hospice : this.generalForm.hospice.trim()],
        MENTAL: [this.generalForm.mental == null ? this.generalForm.mental : this.generalForm.mental.trim()],
        INTCARE: [this.generalForm.intcare == null ? this.generalForm.intcare : this.generalForm.intcare.trim()],
        ONCOLOGY: [this.generalForm.oncology == null ? this.generalForm.oncology : this.generalForm.oncology.trim()],
        IV: [this.generalForm.iv == null ? this.generalForm.iv : this.generalForm.iv.trim()],
        PEDIATRIC: [this.generalForm.pediatric == null ? this.generalForm.pediatric : this.generalForm.pediatric.trim()],
        MATCHILD: [this.generalForm.matchild == null ? this.generalForm.matchild : this.generalForm.matchild.trim()],
        RESIDENTIAL: [this.generalForm.residential == null ? this.generalForm.residential : this.generalForm.residential.trim()],
        STAFF: [this.generalForm.staff == null ? this.generalForm.staff : this.generalForm.staff.trim()],
        GENERIC: [this.generalForm.generic == null ? this.generalForm.generic : this.generalForm.generic.trim()],
        HOSPITAL: [this.generalForm.hospital == null ? this.generalForm.hospital : this.generalForm.hospital.trim()],
        ICU: [this.generalForm.icu == null ? this.generalForm.icu : this.generalForm.icu.trim()],
        LABOR: [this.generalForm.labor == null ? this.generalForm.labor : this.generalForm.labor.trim()],
        MEDSURG: [this.generalForm.medsurg == null ? this.generalForm.medsurg : this.generalForm.medsurg.trim()],
        NURSING: [this.generalForm.nursing == null ? this.generalForm.nursing : this.generalForm.nursing.trim()],
        PEDS: [this.generalForm.peds == null ? this.generalForm.peds : this.generalForm.peds.trim()],
        PRIVATE: [this.generalForm.private == null ? this.generalForm.private : this.generalForm.private.trim()],
        PSYCH: [this.generalForm.psych == null ? this.generalForm.psych : this.generalForm.psych.trim()],
        CLINIC: [this.generalForm.clinic == null ? this.generalForm.clinic : this.generalForm.clinic.trim()],
        CLINIC21: [this.generalForm.clinic21 == null ? this.generalForm.clinic21 : this.generalForm.clinic21.trim(), [Validators.required]],
        OTHERSTAFF: [this.generalForm.otherstaff == null ? this.generalForm.otherstaff : this.generalForm.otherstaff.trim()],
        // tslint:disable-next-line:max-line-length
        OTHERSTAFF2: [this.generalForm.otherstaff2 == null ? this.generalForm.otherstaff2 : this.generalForm.otherstaff2.trim(), [Validators.required]],
      }),
      */
      additionalQuestPage: this.fb.group({
        DENIED: [this.generalForm.denied == null ? this.generalForm.denied : this.generalForm.denied.trim(), [Validators.required]],
        // tslint:disable-next-line:max-line-length
        DISCHARGED: [this.generalForm.discharged == null ? this.generalForm.discharged : this.generalForm.discharged.trim(), [Validators.required]],
        REVOKED: [this.generalForm.revoked == null ? this.generalForm.revoked : this.generalForm.revoked.trim(), [Validators.required]],
        RELATIVE: [this.generalForm.relative == null ? this.generalForm.relative : this.generalForm.relative.trim(), [Validators.required]],
        WORKED: [this.generalForm.worked == null ? this.generalForm.worked : this.generalForm.worked.trim(), [Validators.required]],
        OTHERREASON: [this.generalForm.otherreason]
      }),
      termsPage: this.fb.group({
        // tslint:disable-next-line:max-line-length
        ELECSIGACQ2: [this.generalForm.elecsigacq2 == null ? this.generalForm.elecsigacq2 : this.generalForm.elecsigacq2.trim(), [Validators.required]],
        // tslint:disable-next-line:max-line-length
        ELECSIGACQ12: [this.generalForm.elecsigacq12 == null ? this.generalForm.elecsigacq12 : this.generalForm.elecsigacq12.trim(), [Validators.required]],
        // tslint:disable-next-line:max-line-length
        ELECSIGACQ3: [this.generalForm.elecsigacq3 == null ? this.generalForm.elecsigacq3 : this.generalForm.elecsigacq3.trim(), [Validators.required]],
      })
    });
  }




  initEdForm() {

this.appeducationForm = this.fb.group({
        Id: [this.educationModel[0].id, [Validators.required]],
        HSType: [this.educationModel[0].type, [Validators.required]],
        HSName: [this.educationModel[0].name, [Validators.required]],
        HSLocation: [this.educationModel[0].location, [Validators.required]],
        HSLast_Year_Completed: [this.educationModel[0].last_Year_Completed, [Validators.required]],
        HSGraduate: [this.educationModel[0].graduate, [Validators.required]],
        GED: [{value: this.educationModel[0].ged, disabled: this.educationModel[0].ged === '' ? true : false}, [Validators.required]],

        Id1: [this.educationModel[1] == null ? '0' : this.educationModel[1].id],
        ColType: [this.educationModel[1] == null ? '' : this.educationModel[1].type],
        ColName: [this.educationModel[1] == null ? '' : this.educationModel[1].name],
        ColLocation: [this.educationModel[1] == null ? '' : this.educationModel[1].location],
        ColLast_Year_Completed: [this.educationModel[1] == null ? '' : this.educationModel[1].last_Year_Completed],
        ColGraduate: [this.educationModel[1] == null ? '' : this.educationModel[1].graduate],
        ColMajor_Course: [this.educationModel[1] == null ? '' : this.educationModel[1].major_Course],
        ColDiploma_Degree: [this.educationModel[1] == null ? '' : this.educationModel[1].diploma_Degree],


        Id2: [this.educationModel[2] == null ? '0' : this.educationModel[2].id],
        OTHType: [this.educationModel[2] == null ? '' : this.educationModel[2].type],
        OTHName: [this.educationModel[2] == null ? '' : this.educationModel[2].name],
        OTHLocation: [this.educationModel[2] == null ? '' : this.educationModel[2].location],
        OTHLast_Year_Completed: [this.educationModel[2] == null ? '' : this.educationModel[2].last_Year_Completed],
        OTHGraduate: [this.educationModel[2] == null ? '' : this.educationModel[2].graduate],
        OTHMajor_Course: [this.educationModel[2] == null ? '' : this.educationModel[2].major_Course],
        OTHDiploma_Degree: [this.educationModel[2] == null ? '' : this.educationModel[2].diploma_Degree],
        disablename: [false], // rowcount===0 ? "" : Education[0].graduate === 'Yes'? true:false,
        ApplicantFormId: [this.appId],

      });

  }




  initWorkHistoryForm() {

    this.appworkhistoryForm = this.fb.group({

            Id1:   [this.workhistoryModel[0].id],
            CO1AUTH: [this.workhistoryModel[0].coauth === 'No' || this.workhistoryModel[0].coauth === '' ? false : true],
            CO1NAME: [this.workhistoryModel[0].coname, [Validators.required]],
            CO1FROMMTH1: [this.workhistoryModel[0].cofrommth1, [Validators.required]],
            CO1FROMYR: [this.workhistoryModel[0].cofromyr, [Validators.required]],
            CO1TOMTH1: [this.workhistoryModel[0].cotomth1, [Validators.required]],
            CO1TOYR: [this.workhistoryModel[0].cotoyr, [Validators.required]],
            CO1ADD: [this.workhistoryModel[0].coadd, [Validators.required]],
            CO1ADD2: [this.workhistoryModel[0].coadd2, [Validators.required]],
            CO1POS: [this.workhistoryModel[0].copos, [Validators.required]],
            SUPER: [this.workhistoryModel[0].super, [Validators.required]],
            CO1PHONE: [this.workhistoryModel[0].cophone, [Validators.required]],
            CO1EMAIL: [this.workhistoryModel[0].coemail],
            CO1REASON: [this.workhistoryModel[0].coreason, [Validators.required]],

            Id2:   [this.workhistoryModel[1] == null ? 0 : this.workhistoryModel[1].id ],
            // tslint:disable-next-line:max-line-length
            CO2AUTH: [this.workhistoryModel[1] == null ? '' : this.workhistoryModel[1].coauth === 'No' || this.workhistoryModel[1].coauth === '' ? false : true],
            CO2NAME: [this.workhistoryModel[1] == null ? '' : this.workhistoryModel[1].coname],
            CO2FROMMTH2: [this.workhistoryModel[1] == null ? '' : this.workhistoryModel[1].cofrommth1],
            CO2FROMYR: [this.workhistoryModel[1] == null ? '' : this.workhistoryModel[1].cofromyr],
            CO2TOMTH2: [this.workhistoryModel[1] == null ? '' : this.workhistoryModel[1].cotomth1],
            CO2TOYR: [this.workhistoryModel[1] == null ? '' : this.workhistoryModel[1].cotoyr],
            CO2ADD: [this.workhistoryModel[1] == null ? '' : this.workhistoryModel[1].coadd],
            CO2ADD2: [this.workhistoryModel[1] == null ? '' : this.workhistoryModel[1].coadd2],
            CO2POS: [this.workhistoryModel[1] == null ? '' : this.workhistoryModel[1].copos],
            SUPER2: [this.workhistoryModel[1] == null ? '' : this.workhistoryModel[1].super],
            CO2PHONE: [this.workhistoryModel[1] == null ? '' : this.workhistoryModel[1].cophone],
            CO2EMAIL: [this.workhistoryModel[1] == null ? '' : this.workhistoryModel[1].coemail],
            CO2REASON: [this.workhistoryModel[1] == null ? '' : this.workhistoryModel[1].coreason],


            Id3:   [this.workhistoryModel[2] == null ? 0 : this.workhistoryModel[2].id],
            // tslint:disable-next-line:max-line-length
            CO3AUTH: [this.workhistoryModel[2] == null ? '' : this.workhistoryModel[2].coauth === 'No' || this.workhistoryModel[2].coauth === ''  ? false : true],
            CO3NAME: [this.workhistoryModel[2] == null ? '' : this.workhistoryModel[2].coname],
            CO3FROMMTH3: [this.workhistoryModel[2] == null ? '' : this.workhistoryModel[2].cofrommth1],
            CO3FROMYR: [this.workhistoryModel[2] == null ? '' : this.workhistoryModel[2].cofromyr],
            CO3TOMTH3: [this.workhistoryModel[2] == null ? '' : this.workhistoryModel[2].cotomth1],
            CO3TOYR: [this.workhistoryModel[2] == null ? '' : this.workhistoryModel[2].cotoyr],
            CO3ADD: [this.workhistoryModel[2] == null ? '' : this.workhistoryModel[2].coadd],
            CO3ADD2: [this.workhistoryModel[2] == null ? '' : this.workhistoryModel[2].coadd2],
            CO3POS: [this.workhistoryModel[2] == null ? '' : this.workhistoryModel[2].copos],
            SUPER3: [this.workhistoryModel[2] == null ? '' : this.workhistoryModel[2].super],
            CO3PHONE: [this.workhistoryModel[2] == null ? '' : this.workhistoryModel[2].cophone],
            CO3EMAIL: [this.workhistoryModel[2] == null ? '' : this.workhistoryModel[2].coemail],
            CO3REASON: [this.workhistoryModel[2] == null ? '' : this.workhistoryModel[2].coreason],


           ApplicantFormId: [this.appId],
            WHAR: [this.workhistoryModel[0].whar === 'No' || this.workhistoryModel[0].whar === '' ? false : true],
            noemploy: [this.workhistoryModel[0].noemploy === 'No' || this.workhistoryModel[0].noemploy === '' ? false : true],
            noemployexp: [this.workhistoryModel[0].noemployexp, [Validators.required]],
            disablename: false,
            disablenameexplain: false

          });
      }




      initRefForm() {

        this.appreferencesForm = this.fb.group({
                Id: [this.referenceModel[0].id],
                ReferenceName: [this.referenceModel[0].referenceName, [Validators.required]],
                ReferenceSupervisor: [this.referenceModel[0].referenceSupervisor, [Validators.required]],
                ReferenceAddress: [this.referenceModel[0].referenceAddress, [Validators.required]],
                ReferenceTelephone: [this.referenceModel[0].referenceTelephone, [Validators.required]],
                ReferenceEmail: [this.referenceModel[0].referenceEmail],
                ReferenceFax: [this.referenceModel[0].referenceFax],

                Id1: [this.referenceModel[1] == null ? '0' : this.referenceModel[1].id],
                ReferenceName1: [this.referenceModel[1] == null ? '' : this.referenceModel[1].referenceName],
                // tslint:disable-next-line:max-line-length
                ReferenceSupervisor1: [this.referenceModel[1] == null ? '' : this.referenceModel[1].referenceSupervisor],
                ReferenceAddress1: [this.referenceModel[1] == null ? '' : this.referenceModel[1].referenceAddress],
                ReferenceTelephone1: [this.referenceModel[1] == null ? '' : this.referenceModel[1].referenceTelephone],
                ReferenceEmail1: [this.referenceModel[1] == null ? '' : this.referenceModel[1].referenceEmail],
                ReferenceFax1: [this.referenceModel[1] == null ? '' : this.referenceModel[1].referenceFax],


                Id2: [this.referenceModel[2] == null ? '0' : this.referenceModel[2].id],
                ReferenceName2: [this.referenceModel[2] == null ? '' : this.referenceModel[2].referenceName],
                // tslint:disable-next-line:max-line-length
                ReferenceSupervisor2: [this.referenceModel[2] == null ? '' : this.referenceModel[2].referenceSupervisor],
                ReferenceAddress2: [this.referenceModel[2] == null ? '' : this.referenceModel[2].referenceAddress],
                ReferenceTelephone2: [this.referenceModel[2] == null ? '' : this.referenceModel[2].referenceTelephone],
                ReferenceEmail2: [this.referenceModel[2] == null ? '' : this.referenceModel[2].referenceEmail],
                ReferenceFax2: [this.referenceModel[2] == null ? '' : this.referenceModel[2].referenceFax],
                ApplicantFormId: [this.appId],

              });

          }

          /* Changes Md Remove Exams 08/03/2022
          initExamForm() {
            this.appexamForm = this.fb.group({
                ApplicantFormID: [this.appId], // either this when post or have the id passed in through the all as in updateGeneral
                ExamID: [null], // either this when post or have the id passed in through the all as in updateGeneral
                Question1: [this.examModel.Question1 === undefined ? this.examModel.Question1 : this.examModel.Question1.toString()],
                Question2: [this.examModel.Question2 === undefined ? this.examModel.Question2 : this.examModel.Question2.toString()],
                Question3: [this.examModel.Question3 === undefined ? this.examModel.Question3 : this.examModel.Question3.toString()],
                Question4: [this.examModel.Question4 === undefined ? this.examModel.Question4 : this.examModel.Question4.toString()],
                Question5: [this.examModel.Question5 === undefined ? this.examModel.Question5 : this.examModel.Question5.toString()],
                Question6: [this.examModel.Question6 === undefined ? this.examModel.Question6 : this.examModel.Question6.toString()],
                Question7: [this.examModel.Question7 === undefined ? this.examModel.Question7 : this.examModel.Question7.toString()],
                Question8: [this.examModel.Question8 === undefined ? this.examModel.Question8 : this.examModel.Question8.toString()],
                Question9: [this.examModel.Question9 === undefined ? this.examModel.Question9 : this.examModel.Question9.toString()],
                Question10: [this.examModel.Question10 === undefined ? this.examModel.Question10 : this.examModel.Question10.toString()],
                Question11: [this.examModel.Question11 === undefined ? this.examModel.Question11 : this.examModel.Question11.toString()],
                Question12: [this.examModel.Question12 === undefined ? this.examModel.Question12 : this.examModel.Question12.toString()],
                Question13: [this.examModel.Question13 === undefined ? this.examModel.Question13 : this.examModel.Question13.toString()],
                Question14: [this.examModel.Question14 === undefined ? this.examModel.Question14 : this.examModel.Question14.toString()],
                Question15: [this.examModel.Question15 === undefined ? this.examModel.Question15 : this.examModel.Question15.toString()],
                Question16: [this.examModel.Question16 === undefined ? this.examModel.Question16 : this.examModel.Question16.toString()],
                Question17: [this.examModel.Question17 === undefined ? this.examModel.Question17 : this.examModel.Question17.toString()],
                Question18: [this.examModel.Question18 === undefined ? this.examModel.Question18 : this.examModel.Question18.toString()],
                Question19: [this.examModel.Question19 === undefined ? this.examModel.Question19 : this.examModel.Question19.toString()],
                Question20: [this.examModel.Question20 === undefined ? this.examModel.Question20 : this.examModel.Question20.toString()],
                Question21: [this.examModel.Question21 === undefined ? this.examModel.Question21 : this.examModel.Question21.toString()],
                Question22: [this.examModel.Question22 === undefined ? this.examModel.Question22 : this.examModel.Question22.toString()],
                Question23: [this.examModel.Question23 === undefined ? this.examModel.Question23 : this.examModel.Question23.toString()],
                Question24: [this.examModel.Question24 === undefined ? this.examModel.Question24 : this.examModel.Question24.toString()],
                Question25: [this.examModel.Question25 === undefined ? this.examModel.Question25 : this.examModel.Question25.toString()],
                Question26: [this.examModel.Question26 === undefined ? this.examModel.Question26 : this.examModel.Question26.toString()],
                Question27: [this.examModel.Question27 === undefined ? this.examModel.Question27 : this.examModel.Question27.toString()],
                Question28: [this.examModel.Question28 === undefined ? this.examModel.Question28 : this.examModel.Question28.toString()],
                Question29: [this.examModel.Question29 === undefined ? this.examModel.Question29 : this.examModel.Question29.toString()],
                Question30: [this.examModel.Question30 === undefined ? this.examModel.Question30 : this.examModel.Question30.toString()],
                Question31: [this.examModel.Question31 === undefined ? this.examModel.Question31 : this.examModel.Question31.toString()],
                Question32: [this.examModel.Question32 === undefined ? this.examModel.Question32 : this.examModel.Question32.toString()],
                Question33: [this.examModel.Question33 === undefined ? this.examModel.Question33 : this.examModel.Question33.toString()],
                Question34: [this.examModel.Question34 === undefined ? this.examModel.Question34 : this.examModel.Question34.toString()],
                Question35: [this.examModel.Question35 === undefined ? this.examModel.Question35 : this.examModel.Question35.toString()],
                Question36: [this.examModel.Question36 === undefined ? this.examModel.Question36 : this.examModel.Question36.toString()],
                Question37: [this.examModel.Question37 === undefined ? this.examModel.Question37 : this.examModel.Question37.toString()],
                Question38: [this.examModel.Question38 === undefined ? this.examModel.Question38 : this.examModel.Question38.toString()],
                Question39: [this.examModel.Question39 === undefined ? this.examModel.Question39 : this.examModel.Question39.toString()],
                Question40: [this.examModel.Question40 === undefined ? this.examModel.Question40 : this.examModel.Question40.toString()],
                Question41: [this.examModel.Question41 === undefined ? this.examModel.Question41 : this.examModel.Question41.toString()],
                Question42: [this.examModel.Question42 === undefined ? this.examModel.Question42 : this.examModel.Question42.toString()],
                Question43: [this.examModel.Question43 === undefined ? this.examModel.Question43 : this.examModel.Question43.toString()],
                Question44: [this.examModel.Question44 === undefined ? this.examModel.Question44 : this.examModel.Question44.toString()],
                Question45: [this.examModel.Question45 === undefined ? this.examModel.Question45 : this.examModel.Question45.toString()],
                Question46: [this.examModel.Question46 === undefined ? this.examModel.Question46 : this.examModel.Question46.toString()],
                Question47: [this.examModel.Question47 === undefined ? this.examModel.Question47 : this.examModel.Question47.toString()],
                Question48: [this.examModel.Question48 === undefined ? this.examModel.Question48 : this.examModel.Question48.toString()],
                Question49: [this.examModel.Question49 === undefined ? this.examModel.Question49 : this.examModel.Question49.toString()],
                Question50: [this.examModel.Question50 === undefined ? this.examModel.Question50 : this.examModel.Question50.toString()],
                Question51: [this.examModel.Question51 === undefined ? this.examModel.Question51 : this.examModel.Question51.toString()],
                Question52: [this.examModel.Question52 === undefined ? this.examModel.Question52 : this.examModel.Question52.toString()],
                Question53: [this.examModel.Question53 === undefined ? this.examModel.Question53 : this.examModel.Question53.toString()],
                Question54: [this.examModel.Question54 === undefined ? this.examModel.Question54 : this.examModel.Question54.toString()],
                Question55: [this.examModel.Question55 === undefined ? this.examModel.Question55 : this.examModel.Question55.toString()],
                Question56: [this.examModel.Question56 === undefined ? this.examModel.Question56 : this.examModel.Question56.toString()],
                Question57: [this.examModel.Question57 === undefined ? this.examModel.Question57 : this.examModel.Question57.toString()],
                Question58: [this.examModel.Question58 === undefined ? this.examModel.Question58 : this.examModel.Question58.toString()],
                Question59: [this.examModel.Question59 === undefined ? this.examModel.Question59 : this.examModel.Question59.toString()],
                Question60: [this.examModel.Question60 === undefined ? this.examModel.Question60 : this.examModel.Question60.toString()],
                Question61: [this.examModel.Question61 === undefined ? this.examModel.Question61 : this.examModel.Question61.toString()],
                Question62: [this.examModel.Question62 === undefined ? this.examModel.Question62 : this.examModel.Question62.toString()],
                Question63: [this.examModel.Question63 === undefined ? this.examModel.Question63 : this.examModel.Question63.toString()],
                Question64: [this.examModel.Question64 === undefined ? this.examModel.Question64 : this.examModel.Question64.toString()],
                Question65: [this.examModel.Question65 === undefined ? this.examModel.Question65 : this.examModel.Question65.toString()],
                Question66: [this.examModel.Question66 === undefined ? this.examModel.Question66 : this.examModel.Question66.toString()],
                Question67: [this.examModel.Question67 === undefined ? this.examModel.Question67 : this.examModel.Question67.toString()],
                Question68: [this.examModel.Question68 === undefined ? this.examModel.Question68 : this.examModel.Question68.toString()],
                Question69: [this.examModel.Question69 === undefined ? this.examModel.Question69 : this.examModel.Question69.toString()],
                Question70: [this.examModel.Question70 === undefined ? this.examModel.Question70 : this.examModel.Question70.toString()],
                Question71: [this.examModel.Question71 === undefined ? this.examModel.Question71 : this.examModel.Question71.toString()],
                Question72: [this.examModel.Question72 === undefined ? this.examModel.Question72 : this.examModel.Question72.toString()],
                Question73: [this.examModel.Question73 === undefined ? this.examModel.Question73 : this.examModel.Question73.toString()],
                Question74: [this.examModel.Question74 === undefined ? this.examModel.Question74 : this.examModel.Question74.toString()],
                Question75: [this.examModel.Question75 === undefined ? this.examModel.Question75 : this.examModel.Question75.toString()],
                Question76: [this.examModel.Question76 === undefined ? this.examModel.Question76 : this.examModel.Question76.toString()],
                Question77: [this.examModel.Question77 === undefined ? this.examModel.Question77 : this.examModel.Question77.toString()],
                Question78: [this.examModel.Question78 === undefined ? this.examModel.Question78 : this.examModel.Question78.toString()],
                Question79: [this.examModel.Question79 === undefined ? this.examModel.Question79 : this.examModel.Question79.toString()],
                Question80: [this.examModel.Question80 === undefined ? this.examModel.Question80 : this.examModel.Question80.toString()],
                Question81: [this.examModel.Question81 === undefined ? this.examModel.Question81 : this.examModel.Question81.toString()],
                Question82: [this.examModel.Question82 === undefined ? this.examModel.Question82 : this.examModel.Question82.toString()],
                Question83: [this.examModel.Question83 === undefined ? this.examModel.Question83 : this.examModel.Question83.toString()],
                Question84: [this.examModel.Question84 === undefined ? this.examModel.Question84 : this.examModel.Question84.toString()],
                Question85: [this.examModel.Question85 === undefined ? this.examModel.Question85 : this.examModel.Question85.toString()],
                Question86: [this.examModel.Question86 === undefined ? this.examModel.Question86 : this.examModel.Question86.toString()],
                Question87: [this.examModel.Question87 === undefined ? this.examModel.Question87 : this.examModel.Question87.toString()],
                Question88: [this.examModel.Question88 === undefined ? this.examModel.Question88 : this.examModel.Question88.toString()],
                Question89: [this.examModel.Question89 === undefined ? this.examModel.Question89 : this.examModel.Question89.toString()],
                Question90: [this.examModel.Question90 === undefined ? this.examModel.Question90 : this.examModel.Question90.toString()],
                Question91: [this.examModel.Question91 === undefined ? this.examModel.Question91 : this.examModel.Question91.toString()],
                Question92: [this.examModel.Question92 === undefined ? this.examModel.Question92 : this.examModel.Question92.toString()],
                Question93: [this.examModel.Question93 === undefined ? this.examModel.Question93 : this.examModel.Question93.toString()],
                Question94: [this.examModel.Question94 === undefined ? this.examModel.Question94 : this.examModel.Question94.toString()],
                Question95: [this.examModel.Question95 === undefined ? this.examModel.Question95 : this.examModel.Question95.toString()],
                Question96: [this.examModel.Question96 === undefined ? this.examModel.Question96 : this.examModel.Question96.toString()],
                Question97: [this.examModel.Question97 === undefined ? this.examModel.Question97 : this.examModel.Question97.toString()],
                Question98: [this.examModel.Question98 === undefined ? this.examModel.Question98 : this.examModel.Question98.toString()],
                Question99: [this.examModel.Question99 === undefined ? this.examModel.Question99 : this.examModel.Question99.toString()],
                // tslint:disable-next-line:max-line-length
                Question100: [this.examModel.Question100 === undefined ? this.examModel.Question100 : this.examModel.Question100.toString()]
            });

          }
          */
}